<template>
  <div v-if="citation" class="jps-citation" :class="{ variation }">
    <p class="citation-header has-text-weight-bold" v-if="variation">
      {{ lss('引用', 'Citation') }}
    </p>
    <p class="citation-body" v-shtml="citationHTML" />
    <p class="has-text-right">
      <UiButtonLinkRound styled="primary" @click="copy()">
        {{ lss('記載例をコピー', 'Copy') }}
      </UiButtonLinkRound>
    </p>
  </div>
</template>

<script lang="ts" setup>
import vShtml from '~/directives/shtml'

const { ls, lss, li, isJa } = useI18n()
const { isJps } = useServiceType()
const { snackbarSuccess } = useSnackbar()
const dataStore = useDataStore()

interface Props {
  variation?: boolean,
  data: any,
  type?: Key
}
const props = withDefaults(defineProps<Props>(),{
  variation: false
})

const url = computed(() => {
  return getFullPath(props.type + '/' + props.data.id)
})

const copy = () => {
  navigator.clipboard.writeText(citation.value).then(() => {
    snackbarSuccess({ ja: 'コピーしました。', en: 'Copied' })
  })
}

const citation = computed(() => {
  if (props.data) {
    if (props.type === 'item') {
      if (isJa.value) {
        return `${unqueNonEmptyArray(
          props.data.common.contributor
        )}『${li(props.data)}』${ isJps ? '（' + ls(
          dataStore.provider(props.data.common.provider)?.name
        ) + '所蔵）' : '' } \n「${ls(
          dataStore.database(props.data.common.database)?.name
        )}」収録\n(${url.value})`
      } else {
        return `${unqueNonEmptyArray(
          props.data.common.contributor
        )}"${li(props.data)}"${ isJps ? ' owned by ' + ls(
          dataStore.provider(props.data.common.provider)?.name
        ) : '' },\n retrieved from ${ls(
          dataStore.database(props.data.common.database)?.name
        )} \n(${url.value})`
      }
    }
  }
  return ''
})

const citationHTML = computed(() => {
  return citation.value.replace(/\n/g, '<br>')
})
</script>

<style lang="scss">
@use '@/assets/styles/scss/vue' as *;

.jps-citation {
  &.variation {
    padding: 0.5rem;
  }
  font-size: 0.875rem;
  .jps-tag {
    margin-top: 0.5rem;
  }
  .citation-header,
  .citation-body {
    color: $jps-gray-100;
  }
}
</style>
